<div v-show="true" v-bind:class="getClassName">
  <input
    type="hidden"
    v-for="(item,index) in getChangeOptionsHiddenInputs"
    v-bind:key="index"
    v-bind:name="index"
    v-bind:value="item"
  />
  <input
    type="hidden"
    v-for="(item,index) in getHiddenInputsWithIds"
    v-bind:key="index"
    v-bind:name="item.name"
    v-bind:id="item.id"
    v-bind:value="item.value"
  />
</div>
